/* user modules */
angular.module('bmsApp.settings', ['ui.router'])
    .config(['$stateProvider', '$urlRouterProvider', 'BMSPermission', function config($stateProvider, $urlRouterProvider, BMSPermission) {
        $stateProvider

            .state('main.settings', {
                url: '/settings',
                views: {
                    'main@main': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: "ng/settings/templates/default.html"
                    },
                },
                ncyBreadcrumb: { label: 'Settings' },

            })

            .state('main.settings.businessDetails', {
                url: '/business-details',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: "ng/settings/businessDetails/templates/BusinessDetailSave.html",
                        controller: 'BusinessDetailCtrl'
                    },
                },
                ncyBreadcrumb: { label: 'Business Details' }
            })

            .state('main.settings.licenseDetails', {
                url: '/license-details',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: "ng/settings/licenseDetails/templates/LicenseDetailSave.html",
                        controller: 'LicenseDetailCtrl'
                    },
                },
                ncyBreadcrumb: { label: 'License Details' }
            })

            .state('main.settings.email', {
                url: '/email',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: "ng/settings/email/templates/EmailSettingSave.html",
                        controller: 'EmailSettingsCtrl'
                    },
                },
                ncyBreadcrumb: { label: 'Email' }
            })

            .state('main.settings.email-accounts', {
                abstract: true,
            })

            .state('main.settings.email-accounts.index', {
                url: '/email-accounts',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: "ng/settings/email-accounts/index/EmailAccountsIndex.html",
                        controller: 'EmailAccountsIndexCtrl',
                        controllerAs: 'EmailAccountsIndex',
                    },
                },
                ncyBreadcrumb: { label: 'Email Accounts' }
            })

            .state('main.settings.email-accounts.edit', {
                url: '/email-accounts/edit/{id:int}',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: "ng/settings/email-accounts/save/EmailAccountsSave.html",
                        controller: 'EmailAccountsSaveCtrl',
                        controllerAs: 'EmailAccountsSave',
                    },
                },
                ncyBreadcrumb: {
                    parent: 'main.settings.email-accounts.index',
                    label: 'Manage email account',
                }
            })

            .state('main.settings.email-accounts.create', {
                url: '/email-accounts/create',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: "ng/settings/email-accounts/save/EmailAccountsSave.html",
                        controller: 'EmailAccountsSaveCtrl',
                        controllerAs: 'EmailAccountsSave',
                    },
                },
                ncyBreadcrumb: {
                    parent: 'main.settings.email-accounts.index',
                    label: 'Manage email account',
                }
            })

            .state('main.settings.mmPayMethods', {
                url: '/pay-methods',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: "ng/settings/MMPayMethod/templates/MMPayMethodSave.html",
                        controller: 'MinPayValueCtrl'
                    },
                },
                ncyBreadcrumb: { label: 'Min Job Value' }
            })

            .state('main.settings.bookingPrompt', {
                url: '/booking-prompt',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: "ng/settings/bookingPrompt/templates/BookingPrompt.html",
                        controller: 'BookingPromptCtrl',
                        controllerAs: 'BookingPrompt',
                    },
                },
                ncyBreadcrumb: { label: 'Booking Propmts' }
            })

            .state('main.settings.smMinJobValue', {
                url: '/min-job-value',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: "ng/settings/minJobValue/templates/MinPayValueSave.html",
                        controller: 'MinPayValueCtrl'
                    },
                },
                ncyBreadcrumb: { label: 'Min Job Value' }
            })

            .state('main.settings.leavingPromptQuestions', {
                url: '/leaving-prompt-questions',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: "ng/settings/leavingPromptQuestions/templates/Questions.html",
                        controller: 'LeavingPromptQuestionCtrl',
                        controllerAs: 'LeavingPromptQuestion',
                    },
                },
                ncyBreadcrumb: { label: 'Leaving Prompt Questions' }
            })

            .state('main.settings.workingHours', {
                url: '/working-hours',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: "ng/settings/workingHours/templates/WorkingHoursSave.html",
                        controller: 'WorkingHoursCtrl'
                    },
                },
                ncyBreadcrumb: { label: 'Working Hours' }
            })

            .state('main.settings.riskAssessmentQuestions', {
                url: '/risk-assessment-questions',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: "ng/settings/riskAssessmentQuestions/templates/Questions.html",
                        controller: 'RiskAssessmentQuestionCtrl',
                        controllerAs: 'RiskAssessmentQuestion',
                    },
                },
                ncyBreadcrumb: { label: 'Risk Assessment Questions' }
            })

            .state('main.settings.roomTypes', {
                url: '/room-types',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: "ng/settings/roomTypes/templates/RoomTypeSave.html",
                        controller: 'RoomTypeSaveCtrl'
                    },
                },
                ncyBreadcrumb: { label: 'Room Settings' }
            })

            .state('main.settings.worksheets', {
                url: '/worksheets',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: 'ng/settings/worksheets/templates/WorksheetPreferences.html',
                        controller: 'WorksheetPreferencesCtrl'
                    }
                },
                ncyBreadcrumb: { label: 'Worksheet Preferences' }
            })
          .state('main.settings.ecom-route-config', {
                url: '/ecom-route-config',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: 'ng/settings/ecomRouteConfiguration/templates/EcomRouteConfiguration.html',
                        controller: 'EcomRouteConfigurationCtrl',
                        controllerAs: 'EcomRouteConfig'
                    }
                },
                ncyBreadcrumb: { label: 'Route Configuration' }
            })

					.state('main.settings.generalTermsAndConditions', {
						url: '/general-terms-and-conditions',
						views: {
							'': { templateUrl: 'ng/settings/templates/settingsMain.html' },
							'content@main.settings': {
								templateUrl: 'ng/settings/generalTermsAndConditions/templates/GeneralTermsAndConditions.html',
								controller: 'GeneralTermsAndConditionsCtrl',
								controllerAs: 'GeneralTermsAndConditions'
							}
						},
						ncyBreadcrumb: { label: 'General Terms And Conditions' }
					})

            .state('main.settings.disclaimerText', {
                url: '/disclaimer-text',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: "ng/settings/forms/disclaimer-text/DisclaimerTextForm.html",
                        controller: 'DisclaimerTextFormCtrl'
                    },
                },
                ncyBreadcrumb: { label: 'Disclaimer Text' }
            })

            .state('main.settings.satisfactionNote', {
                url: '/satisfaction-note',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: "ng/settings/forms/satisfaction-note/SatisfactionNoteForm.html",
                        controller: 'SatisfactionNoteFormCtrl'
                    },
                },
                ncyBreadcrumb: { label: 'Satisfaction Note' }
            })

            .state('main.settings.mm-online-products', {
                url: '/mm/online-products',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: 'ng/settings/mmOnlineProducts/templates/MMonlineProducts.html',
                        controller: 'MMOnlineProductsCtrl'
                    }
                },
                ncyBreadcrumb: { label: 'Online Products' }
            })

            .state('main.settings.stripe-configuration', {
                url: '/stripe',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: 'ng/settings/stripe/templates/StripeConfiguration.html',
                        controller: 'StripeConfigurationCtrl'
                    }
                },
                ncyBreadcrumb: { label: 'Stripe Configuration' }
            })

            .state('main.settings.online-status', {
                url: '/online-status',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: 'ng/settings/onlineStatus/templates/OnlineStatus.html',
                        controller: 'OnlineStatusCtrl',
                        controllerAs: 'OnlineStatus',
                    }
                },
                ncyBreadcrumb: { label: 'Online status' }
            })

            .state('main.settings.online-alert-destination', {
                url: '/ecom-alerts',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: 'ng/settings/ecomAlertDestination/templates/EcomAlertDestination.html',
                        controller: 'EcomAlertDestinationCtrl',
                    }
                },
                ncyBreadcrumb: { label: 'Alert Destinations' }
            })


            .state('main.settings.online-discounts', {
                url: '/online-discounts',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: 'ng/settings/onlineDiscounts/templates/OnlineDiscount.html',
                        controller: 'OnlineDiscountCtrl',
                        controllerAs: 'OnlineDiscount',
                    }
                },
                ncyBreadcrumb: { label: 'Online discounts' }
            })

            .state('main.settings.online-email-redemption-code', {
                url: '/online-email-redemption',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: 'ng/settings/onlineEmailRedemptionCode/templates/OnlineEmailRedemptionCode.html',
                        controller: 'OnlineEmailRedemptionCodeCtrl',
                        controllerAs: 'OnlineEmailRedemptionCode',
                    }
                },
                ncyBreadcrumb: { label: 'Online email redemption code' }
            })

            .state('main.settings.online-slots', {
                url: '/online-slots',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: 'ng/settings/onlineSlots/templates/OnlineSlots.html',
                        controller: 'OnlineSlotsCtrl',
                        controllerAs: 'OnlineSlots',
                    }
                },
                ncyBreadcrumb: { label: 'Online slots' }
            })

            // .state('main.settings.online-terms', {
            //     url: '/online-terms',
            //     views: {
            //         '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
            //         'content@main.settings': {
            //             templateUrl: 'ng/settings/onlineTerms/templates/OnlineTerms.html',
            //             controller: 'OnlineTermsCtrl',
            //             controllerAs: 'OnlineTerms',
            //         }
            //     },
            //     ncyBreadcrumb: { label: 'Online terms' }
            // })

            // Table Manager States
            // .state('main.settings.prospectStatuses', {
            // 	url: '/form-preferences/prospect-status',
            // 	views: {
            // 		'': {templateUrl: 'ng/settings/templates/settingsMain.html'},
            // 		'content@main.settings': {
            // 			templateUrl: "ng/settings/tableManager/templates/TableManagerSave.html",
            // 			controller: 'TableManagerCtrl'
            // 		}
            // 	},
            // 	data: {displayName: 'Prospect Status', model: 'ProspectStatus'},
            // 	ncyBreadcrumb: {label: 'Manage Prospect Statuses'}
            // })
            //
            // .state('main.settings.prospectStages', {
            // 	url: '/form-preferences/prospect-stages',
            // 	views: {
            // 		'': {templateUrl: 'ng/settings/templates/settingsMain.html'},
            // 		'content@main.settings': {
            // 			templateUrl: "ng/settings/tableManager/templates/TableManagerSave.html",
            // 			controller: 'TableManagerCtrl'
            // 		}
            // 	},
            // 	data: {displayName: 'Prospect Stages', model: 'ProspectStage'},
            // 	ncyBreadcrumb: {label: 'Manage Prospect Stages'}
            // })

            .state('main.settings.securityTypes', {
                url: '/form-preferences/security-types',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: "ng/settings/tableManager/templates/TableManagerSave.html",
                        controller: 'TableManagerCtrl'
                    }
                },
                data: { displayName: 'Security Types', model: 'App\\Models\\General\\SecurityType' },
                ncyBreadcrumb: { label: 'Manage Security Types' }
            })

            .state('main.settings.employeeRoles', {
                url: '/form-preferences/employee-roles',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: "ng/settings/tableManager/templates/TableManagerSave.html",
                        controller: 'TableManagerCtrl'
                    }
                },
                data: { displayName: 'Employee Roles', model: 'App\\Models\\Employees\\EmployeeRole' },
                ncyBreadcrumb: { label: 'Manage Employee Roles' }
            })

            .state('main.settings.employeeMileageRates', {
                url: '/form-preferences/employee-rates',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: "ng/settings/tableManager/templates/TableManagerSave.html",
                        controller: 'TableManagerCtrl'
                    }
                },
                data: { displayName: 'Employee Mileage Rates', model: 'App\\Models\\Employees\\EmployeeMileageRate' },
                ncyBreadcrumb: { label: 'Manage Employee Mileage Rates' }
            })


            .state('main.settings.salesTypes', {
                url: '/form-preferences/sales-types',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: "ng/settings/salesTypes/templates/SalesTypeSave.html",
                        controller: 'SalesTypeCtrl'
                    }
                },
                ncyBreadcrumb: { label: 'Manage Sales Types' }
            })

            .state('main.settings.vatRates', {
                url: '/form-preferences/vat-rates',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: "ng/settings/vatRates/templates/VATRateSave.html",
                        controller: 'VATRateCtrl'
                    }
                },
                ncyBreadcrumb: { label: 'Manage VAT Rates' }
            })

            .state('main.settings.mmCleaningInstructions', {
                url: '/form-preferences/cleaning-instructions',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: "ng/settings/tableManager/templates/TableManagerSave.html",
                        controller: 'TableManagerCtrl'
                    }
                },
                data: { displayName: 'Cleaning Instructions', model: 'App\\Models\\Merrymaids\\CleaningInstruction' },
                ncyBreadcrumb: { label: 'Manage Cleaning Instructions' }
            })

            .state('main.settings.nominalCodes', {
                url: '/form-preferences/nominal-codes',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: "ng/settings/tableManager/templates/TableManagerSave.html",
                        controller: 'TableManagerCtrl'
                    }
                },
                data: { displayName: 'Nominal Codes', model: 'App\\Models\\General\\NominalCode' },
                ncyBreadcrumb: { label: 'Manage Nominal Codes' }
            })

            .state('main.settings.taxCodes', {
                url: '/form-preferences/sales-types',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: "ng/settings/tableManager/templates/TableManagerSave.html",
                        controller: 'TableManagerCtrl'
                    }
                },
                data: { displayName: 'Sage Tax Codes', model: 'App\\Models\\Accounting\\TCode' },
                ncyBreadcrumb: { label: 'Manage Sage Tax Codes' }
            })

            .state('main.settings.mailchimp', {
                url: '/mailchimp',
                //							params: { model: {}, friendlyName: {} },
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: "ng/settings/mailchimp/templates/mailchimpSettings.html",
                        controller: 'MailchimpSettingsCtrl'
                    },
                },
                ncyBreadcrumb: { label: 'Edit' }
            })

            .state('main.settings.textlocal', {
                url: '/textlocal',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: 'ng/settings/textlocal/templates/TextlocalSettings.html',
                        controller: 'TextlocalSettingsCtrl'
                    }
                },
                ncyBreadcrumb: { label: 'Textlocal' }
            })

            .state('main.settings.webexInteractSMSIntegration', {
                url: '/webex-interact-sms-integration',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: 'ng/settings/webexInteractSMSIntegration/templates/WebexInteractSMSIntegration.html',
                        controller: 'WebexIntegrationCtrl'
                    }
                },
                ncyBreadcrumb: { label: 'Webex Interact SMS Integration' }
            })
            .state('main.settings.mobileSettings', {
                url: '/mobile-settings',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: 'ng/settings/mobileSettings/templates/MobileSettings.html',
                        controller: 'MobileSettingsCtrl'
                    }
                },
                ncyBreadcrumb: { label: 'Mobile Settings' }
            })
            .state('main.settings.customerReminders', {
                url: '/customer-reminders',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: 'ng/settings/customerReminders/templates/CustomerReminderSettings.html',
                        controller: 'CustomerReminderSettingsCtrl'
                    }
                },
                ncyBreadcrumb: { label: 'Customer Reminders' }
            })

            .state('main.settings.customerReminderTemplates', {
                url: '/customer-reminder-templates',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: 'ng/settings/customerReminderTemplates/templates/ReminderTemplates.html',
                        controller: 'ReminderTemplateCtrl',
                        controllerAs: 'ReminderTemplate'
                    }
                },
                ncyBreadcrumb: { label: 'Customer Reminder Templates' }
            })

            .state('main.settings.notificationTemplates', {
                url: '/notification-templates',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: 'ng/settings/notificationTemplates/templates/NotificationTemplates.html',
                        controller: 'NotificationTemplateCtrl',
                        controllerAs: 'TemplateCtrl'
                    }
                },
                ncyBreadcrumb: { label: 'Notification Templates' }
            })

            .state('main.settings.jobAlerts', {
                url: '/job-alerts',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: "ng/settings/job-alerts/JobAlerts.html",
                        controller: 'JobAlertsCtrl',
                        controllerAs: 'JobAlerts',
                    },
                },
                ncyBreadcrumb: { label: 'Job Alerts' }
            })

            .state('main.settings.gdprCleansingEnquiries', {
                url: '/gdpr-cleansing/enquiries',
                views: {
                    '': {
                        templateUrl: 'ng/settings/templates/settingsMain.html'
                    },
                    'content@main.settings': {
                        templateUrl: "ng/settings/gdprCleansing/templates/EnquiryIndex.html",
                        controller: 'EnquiryGdprCleansingIndexCtrl'
                    },
                },
                ncyBreadcrumb: { label: 'GDPR Cleansing - Enquiries' }
            })

            .state('main.settings.gdprCleansingCustomers', {
                url: '/gdpr-cleansing/customers',
                views: {
                    '': {
                        templateUrl: 'ng/settings/templates/settingsMain.html'
                    },
                    'content@main.settings': {
                        templateUrl: "ng/settings/gdprCleansing/templates/CustomerIndex.html",
                        controller: 'CustomerGdprCleansingIndexCtrl'
                    },
                },
                ncyBreadcrumb: { label: 'GDPR Cleansing - Customers' }
            })


            .state('main.settings.userManagement', {
                url: '/user-management',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: "ng/settings/userManagement/templates/UserManagementList.html",
                        controller: 'UserManagementIndexCtrl'
                    },
                },
                ncyBreadcrumb: { label: 'User Management' }
            })

            .state('main.settings.userManagement.create', {
                url: '/user-management/create',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: "ng/settings/userManagement/templates/UserManagementSave.html",
                        controller: 'UserManagementSaveCtrl'
                    },
                },
                ncyBreadcrumb: { label: 'Create New User' }
            })


			.state('main.settings.userManagement.employeeCreate', {
				url: '/user-management/create/employee/{employeeId}',
				views: {
					'': {templateUrl: 'ng/settings/templates/settingsMain.html'},
					'content@main.settings': {
						templateUrl: "ng/settings/userManagement/templates/UserManagementSave.html",
						controller: 'UserManagementSaveCtrl'
					},
				},
				ncyBreadcrumb: {label: 'Create New User'}
			})

			.state('main.settings.userManagement.edit', {
				url: '/user-management/:id',
				views: {
					'': {templateUrl: 'ng/settings/templates/settingsMain.html'},
					'content@main.settings': {
						templateUrl: "ng/settings/userManagement/templates/UserManagementSave.html",
						controller: 'UserManagementSaveCtrl'
					},
				},
				ncyBreadcrumb: {label: 'Edit User'}
			})

            .state('main.settings.userRoles', {
                url: '/user-roles',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: "ng/settings/userManagement/templates/UserRoleIndex.html",
                        controller: 'UserRoleIndexCtrl'
                    },
                },
                ncyBreadcrumb: { label: 'User Roles' }
            })

            .state('main.settings.userRoles.create', {
                url: '/user-roles/create',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: "ng/settings/userManagement/templates/UserRoleSave.html",
                        controller: 'UserRoleSaveCtrl'
                    },
                },
                ncyBreadcrumb: { label: 'Create New Role' }
            })

            .state('main.settings.userRoles.edit', {
                url: '/user-roles/:id',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: "ng/settings/userManagement/templates/UserRoleSave.html",
                        controller: 'UserRoleSaveCtrl'
                    },
                },
                ncyBreadcrumb: { label: 'Edit Role' }
            })

            .state('main.settings.myProfile', {
                url: '/my-profile',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: "ng/settings/profile/templates/UserProfileSave.html",
                        controller: 'UserProfileSaveCtrl'
                    },
                },
                ncyBreadcrumb: { label: 'My Profile' }
            })

            .state('main.settings.smCleaningServices', {
                url: '/cleaning-services',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: "ng/settings/SMCleaningServices/templates/CleaningServicesSave.html",
                        controller: 'CleaningServicesCtrl'
                    },
                },
                ncyBreadcrumb: { label: 'Cleaning Services' }
            })

            .state('main.settings.smHouseTemplatesIndex', {
                url: '/sm/house-templates',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: "ng/settings/SMHouseTemplates/templates/HouseTemplateIndex.html",
                        controller: 'SMHouseTemplateIndexCtrl'
                    },
                },
                ncyBreadcrumb: { label: 'House templates' }
            })

            .state('main.settings.smHouseTemplatesIndex.create', {
                url: '/sm/house-templates/create',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: "ng/settings/SMHouseTemplates/templates/HouseTemplateSave.html",
                        controller: 'SMHouseTemplateSaveCtrl'
                    },
                },
                ncyBreadcrumb: { label: 'Create' }
            })

            .state('main.settings.smHouseTemplatesIndex.update', {
                url: '/sm/house-templates/update/{houseTemplateId}',
                views: {
                    '': { templateUrl: 'ng/settings/templates/settingsMain.html' },
                    'content@main.settings': {
                        templateUrl: "ng/settings/SMHouseTemplates/templates/HouseTemplateSave.html",
                        controller: 'SMHouseTemplateSaveCtrl'
                    },
                },
                ncyBreadcrumb: { label: 'Create' }
            })

					.state('main.settings.bulkPriceUpdate', {
						url: '/bulk-price-update',
						views: {
							'': { templateUrl: 'ng/settings/templates/settingsMain.html' },
							'content@main.settings': {
								templateUrl: 'ng/settings/bulkPriceUpdate/templates/BulkPriceUpdate.html',
								controller: 'BulkPriceUpdateCtrl'
							}
						},
						ncyBreadcrumb: { label: 'Bulk Price Update' }
					})

    }]);
